import clsx from 'clsx';
import Link from 'next/link';

import styles from './TrustPilotReviews.module.scss';

import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import Image from '@/src/shared/components/Image';
import { Typography } from '@/src/shared/components/Typography';

interface Props {
  className?: string;
}

export const TrustPilotReviews = ({ className }: Props) => {
  const isMobile = useIsMobile();

  return (
    <Link
      className={clsx(styles.container, className)}
      href="https://ca.trustpilot.com/review/roomvu.com"
      target="_blank"
    >
      <div className={styles.row}>
        <Image
          src="/next-public/images/home/v6/ratings/trust-pilot.png"
          width={isMobile ? 135 : 219}
          height={isMobile ? 50 : 81}
          alt="trust-pilot-score"
        />
        <Typography
          variant="text"
          size={isMobile ? 'sm' : 'lg'}
          fontWeight="semibold"
        >
          4.5
        </Typography>
      </div>
      <Typography
        tag="span"
        variant="text"
        size={isMobile ? 'xs' : 'sm'}
        fontWeight="regular"
      >
        based on 246 reviews
      </Typography>
    </Link>
  );
};
